
/* ═══════════════════════════════════════════════
   TruSmile — Antes / Después (slider)
   assets/trusmile-before-after.js
 
   Arrastre (mouse + touch) + el divisor sigue el mouse
   al pasar por encima. Al salir, vuelve suave al inicio.
   ═══════════════════════════════════════════════ */
 
(function () {
  'use strict';
 
  function initStage(stage) {
    const clip = stage.querySelector('[data-tbf-clip]');
    const handle = stage.querySelector('[data-tbf-handle]');
    if (!clip || !handle) return;
 
    const start = clampNum(parseFloat(stage.dataset.start), 50);
    const hoverFollow = stage.dataset.hover === 'true';
    let pos = start;
    let dragging = false;
 
    function clampNum(n, fallback) { return isNaN(n) ? fallback : Math.max(0, Math.min(100, n)); }
 
    function apply(p, animate) {
      pos = Math.max(0, Math.min(100, p));
      stage.classList.toggle('is-animating', !!animate);
      clip.style.clipPath = 'inset(0 ' + (100 - pos) + '% 0 0)';
      handle.style.left = pos + '%';
      handle.setAttribute('aria-valuenow', String(Math.round(pos)));
    }
 
    function posFromX(clientX) {
      const r = stage.getBoundingClientRect();
      if (!r.width) return pos;
      return ((clientX - r.left) / r.width) * 100;
    }
 
    // estado inicial (sin animación)
    apply(start, false);
 
    stage.addEventListener('pointerdown', function (e) {
      dragging = true;
      try { stage.setPointerCapture(e.pointerId); } catch (_) {}
      stage.classList.add('is-grabbing');
      apply(posFromX(e.clientX), false);
      if (e.pointerType === 'mouse') e.preventDefault();
    });
 
    stage.addEventListener('pointermove', function (e) {
      if (dragging) {
        apply(posFromX(e.clientX), false);
      } else if (hoverFollow && e.pointerType === 'mouse') {
        apply(posFromX(e.clientX), false);
      }
    });
 
    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      stage.classList.remove('is-grabbing');
      if (e && e.pointerId != null) { try { stage.releasePointerCapture(e.pointerId); } catch (_) {} }
    }
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);
 
    // al salir con el mouse (sin arrastrar), vuelve suave al inicio
    stage.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'mouse' && !dragging && hoverFollow) apply(start, true);
    });
 
    // teclado (accesibilidad)
    handle.addEventListener('keydown', function (e) {
      const step = e.shiftKey ? 10 : 3;
      if (e.key === 'ArrowLeft') { apply(pos - step, false); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { apply(pos + step, false); e.preventDefault(); }
      else if (e.key === 'Home') { apply(0, false); e.preventDefault(); }
      else if (e.key === 'End') { apply(100, false); e.preventDefault(); }
    });
  }
 
  function boot() {
    document.querySelectorAll('[data-tbf]').forEach(initStage);
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();